(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.maxQuantity = parseInt(this.dataset.maxQuantity, 10);
      this.productId = parseInt(this.dataset.productId, 10);

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );

      this.onCartUpdated = this.onCartUpdated.bind(this);
      document.addEventListener('cart:updated', this.onCartUpdated);
    }

    async onSubmitHandler(event) {
      event.preventDefault();
      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      if (this.maxQuantity) {
        const qtyInCart = await this.getQtyInCart();
        const qtyToAdd = parseInt(formData.get('quantity'), 10);

        if (qtyInCart + qtyToAdd >= this.maxQuantity) {
          formData.set('quantity', (this.maxQuantity - qtyInCart).toString());
        }
      }

      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${window.shopUrl}/${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          document.dispatchEvent(new Event('cart:updated'));
          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;
      errorWrapper.classList.toggle('hidden', !errorMessage);
      errorWrapper.textContent = errorMessage || '';
    }

    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
        } else if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }

    async onCartUpdated() {
      if (!this.maxQuantity) {
        return;
      }

      const qtyInCart = await this.getQtyInCart();

      this.submitButton.disabled = qtyInCart >= this.maxQuantity;
      this.submitButton.textContent = theme.strings.product[qtyInCart >= this.maxQuantity ? 'maxInCart' : 'addToCart'];
    }

    async getQtyInCart() {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const qtyInCart = cart.items
        .filter((item) => item.product_id === this.productId)
        .reduce((total, current) => total + current.quantity, 0);

      return qtyInCart;
    }
  }

  customElements.define('product-form', ProductForm);
})();
